module.exports = __webpack_public_path__ + "img/interim-storage.385a0d4d.svg";